import { ROUTE_NAME } from '@constants';
import { AuthAdapter as CoreAuthAdapter } from '@core/adapters';
import axios from 'axios';

export class AuthAdapter extends CoreAuthAdapter {
  async handleSignInError(error: unknown): Promise<never> {
    if (axios.isAxiosError(error) && error.response) {
      const errorCode = error.response.data.status;
      if (errorCode === 'ID_PASSWORD_MISMATCH_FORWARD_TO_PW_FIND_VIEW') {
        await this.router.push({ name: ROUTE_NAME.FindId });
      }
    }
    throw error;
  }
}
